import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/affiliation-programs/PageContent.tsx");
